export const environment = {
  production: true,
  version: require('../../package.json').version,
  PENSION_OUTLOOK_URL: './pension-outlook-api/'
};
